<template>
  <CardCTA
    :button-text="t('PAYJOY_CARD_VIEWS.ELIGIBLE_BTN_TEXT')"
    @link-click="goToCardOverview"
    :link-text="t('PAYJOY_CARD_VIEWS.WHAT_IS_PC')"
    @btn-click="clickActionBtn"
  >
    <div class="w-100 h-100 text-center">
      <span class="eligible-title-1">
        {{ t("PAYJOY_CARD_VIEWS.ELIGIBLE_TITLE_1") }}
      </span>
      <br />
      <span class="eligible-title-2">
        {{ t("PAYJOY_CARD_VIEWS.ELIGIBLE_TITLE_2") }}
      </span>
    </div>
  </CardCTA>
</template>

<script setup lang="ts">
import CardCTA from "@/apps/credit-line/components/CreditCard/CardCTA.vue";

import { useI18n } from "@/apps/credit-line/composables/useI18n";

const { t } = useI18n();

const emit = defineEmits<{
  (e: "goToCardOverview"): void;
  (e: "clickActionBtn"): void;
}>();

const goToCardOverview = () => {
  emit("goToCardOverview");
};

const clickActionBtn = () => {
  emit("clickActionBtn");
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.eligible-title-1 {
  color: #666666;
  font-size: 20px;
  font-family: Inter;
  font-weight: 600;
  word-wrap: break-word;
  font-style: semi-bold;
}

.eligible-title-2 {
  color: #2c7040;
  font-size: 20px;
  font-family: Inter;
  font-weight: 600;
  word-wrap: break-word;
  font-style: semi-bold;
}
</style>
